<mat-toolbar class="toolbar">
    @if (domainSettings && cesarApplications.length > 0) {
    <div class="menu-settings-div">
        <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon class="dashboard-icon">apps</mat-icon>
        </button>
        <mat-menu #menu="matMenu" class="avmup-menu">
            @for (app of cesarApplications; track app) {
            <a href="{{ getUrl(app.url) }}" mat-menu-item class="avmup-menu-item">
                <img class="app-icon" src="{{ app.icon }}" />
                <span>{{ app.display }}</span>
            </a>
            }
        </mat-menu>
        <img class="domain-icon" src="{{ domainSettings.logo }}" />
    </div>
    }

    <span class="application-title">Centrex UI</span>

    <span class="space"></span>

    <div class="search-organization">
        @if (searchControl && currentOrganization) {
        <form [formGroup]="searchControl">
            <mat-form-field [ngClass]="{ 'label-search-hidden': isEditable, 'label-search': true }" (click)="onEdit()">
                <mat-label>{{ 'NavTopBar.Organizations' | translate }}</mat-label>
                <input matInput type="text" formControlName="organization" readonly />
                <mat-icon>close</mat-icon>
            </mat-form-field>
            <mat-form-field [ngClass]="{ 'form-search-hidden': !isEditable, 'form-search': true }" appearance="fill">
                <mat-label>{{ 'NavTopBar.Organizations' | translate }}</mat-label>
                <input
                    type="text"
                    #search
                    #trigger="matAutocompleteTrigger"
                    placeholder="Recherche..."
                    matInput
                    formControlName="organizationControl"
                    [matAutocomplete]="auto"
                    (focusout)="focusout()"
                    (focus)="focus()" />
                @if (search.value.length < 1) {
                <mat-icon matSuffix>search</mat-icon>
                }
                <mat-autocomplete
                    autoActiveFirstOption
                    #auto="matAutocomplete"
                    [displayWith]="displayWith"
                    (optionSelected)="selectOrganization($event.option.value); search.blur()">
                    @for (organization of organizationsFilter; track organization.id) {
                    <mat-option [value]="organization">
                        {{ organization.display }}
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </form>
        }
    </div>

    <span class="space"></span>

    <button mat-icon-button (click)="onThemeChange()">
        @if (!isDarkMode) {
        <mat-icon>dark_mode</mat-icon>
        } @if (isDarkMode) {
        <mat-icon>light_mode</mat-icon>
        }
    </button>

    @if (currentUser) {
    <button class="display-button" mat-button [matMenuTriggerFor]="menu">
        <span class="display">{{ currentUser.display ? currentUser.display : currentUser.account }}</span>
        <mat-icon>account_circle</mat-icon>
    </button>
    }

    <mat-menu #menu="matMenu">
        <button mat-menu-item [matMenuTriggerFor]="languages">
            <mat-icon>language</mat-icon>
            <span>{{ 'NavTopBar.Langues' | translate }}</span>
        </button>
        <button mat-menu-item (click)="modifyPassword()">
            <mat-icon>vpn_key</mat-icon>
            <span>{{ 'NavTopBar.ChangePassword' | translate }}</span>
        </button>
        <button mat-menu-item (click)="about()">
            <mat-icon>help_outline</mat-icon>
            <span>{{ 'NavTopBar.AboutTooltip' | translate }}</span>
        </button>
        <button mat-menu-item (click)="logout()">
            <mat-icon>power_settings_new</mat-icon>
            <span>{{ 'NavTopBar.LogoutTooltip' | translate }}</span>
        </button>
    </mat-menu>

    <mat-menu #languages="matMenu">
        <button mat-menu-item (click)="frenchLanguage()">
            <img classe="resize" src="assets/images/france.webp" />
            <span>{{ 'NavTopBar.French' | translate }}</span>
        </button>
        <button mat-menu-item (click)="englishLanguage()">
            <img classe="resize" src="assets/images/united-kingdom.webp" />
            <span>{{ 'NavTopBar.English' | translate }}</span>
        </button>
    </mat-menu>
</mat-toolbar>
